import EventBus from '@/components/mixins/event-bus-mixin'
import _ from 'lodash'
import { useCognitoAuthStore } from '@base-shared/stores/cognito-auth'

export default {
  mixins: [],
  inject: [
    '$currentUser',
    '$utils'
  ],
  data () {
    return {
      datatransPaymentReponse: null
    }
  },
  methods: {
    datatransLightboxCreateAnAlias () {
      if (!CONFIG.DATATRANS_MERCHANT_ID) return

      const datatransKey = CONFIG.DATATRANS_KEY
      const frontEndRedirectUrl = `${window.location.protocol}//${window.location.host}${this.$route.fullPath}?datatransRedirect=1`
      const merchantId = CONFIG.DATATRANS_MERCHANT_ID
      const amount = 0
      const currency = (this.userInfo && this.userInfo.currency) ? this.userInfo.currency : 'CHF'
      const refno = Math.floor(Math.random() * new Date().getTime())
      let sign = null

      const sessionStage = useCognitoAuthStore().sessionStage ?? CONFIG.GLOBAL_STAGE;
      if (!sessionStage || !CONFIG.API_BASE_URLS[sessionStage]) {
        console.error('Invalid or missing stage:', sessionStage);
        return;
      }

      // Get api url depending on the stage where the user belongs
      const apiBaseUrl = CONFIG.API_BASE_URLS[sessionStage] ?? '';

      const datatransStartPayment = () => {
        Datatrans.startPayment({
          form: '#datatransLightboxForm',
          params: {
            merchantId,
            amount,
            currency,
            refno,
            paymentmethod: 'VIS,ECA,PAP',
            sign,
            token: this.$currentUser.getJWToken(),
            frontendSuccessUrl: frontEndRedirectUrl,
            frontendErrorUrl: frontEndRedirectUrl,
            frontendCancelUrl: frontEndRedirectUrl,
            successUrl: `${apiBaseUrl}/payment/redirect`,
            cancelUrl: `${apiBaseUrl}/payment/redirect`,
            errorUrl: `${apiBaseUrl}/payment/redirect`
          }
        })
      }
      const createSignature = (key) => {
        const message = `${merchantId}${amount}${currency}${refno}`
        const enc = new TextEncoder()
        const encoded = enc.encode(message)

        window.crypto.subtle.sign(
          'HMAC',
          key,
          encoded
        )
          .then((signature) => {
            this.$utils.mainLoader(true)
            // Convert signature buffer to Hex
            sign = [...new Uint8Array(signature)].map(x => x.toString(16).padStart(2, '0')).join('')
            datatransStartPayment()
          })
          .catch((err) => {
            this.$utils.mainLoader(false)
            console.error('Failed to create signature', err)
          })
      }

      if (datatransKey) {
        // importKey for Dynamic sign
        const keyData = new Uint8Array(CONFIG.DATATRANS_KEY.match(/../g).map(h => parseInt(h, 16))).buffer
        window.crypto.subtle.importKey(
          'raw',
          keyData,
          {
            name: 'HMAC',
            hash: { name: 'SHA-256' }
          },
          true,
          ['sign', 'verify']
        )
          .then((key) => {
            this.$utils.mainLoader(true)
            createSignature(key)
          })
          .catch((err) => {
            this.$utils.mainLoader(false)
            console.error('Failed to import key', err)
          })
      } else {
        sign = CONFIG.DATATRANS_SIGN
        datatransStartPayment()
      }
    },
    datatransLightboxPaymentResponseData () {
      const dataTransQueryStringLookup = ['datatransRedirect', 'status', 'refno']
      const isPlansPage = this.$route.name === 'plans'
      let countQueryStringLookup = 0

      if (this.$route.query) {
        for (const key in this.$route.query) {
          for (const qSLIndx in dataTransQueryStringLookup) {
            if (key === dataTransQueryStringLookup[qSLIndx]) {
              countQueryStringLookup += 1
            }
          }
        }
      }

      // Found Datatrans payment response data
      if (dataTransQueryStringLookup.length === countQueryStringLookup) {
        const datatransPaymentReponseData = this.$route.query
        this.datatransPaymentReponse = datatransPaymentReponseData

        if (datatransPaymentReponseData.status === 'error') {
          if (isPlansPage && this.$refs.dialog) {
            if (_.isFunction(this.handleDatatransResponseData)) {
              this.handleDatatransResponseData({
                failed: true,
                data: datatransPaymentReponseData
              })
            }

            return
          } else {
            EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
              type: 'error',
              alert: {
                message: datatransPaymentReponseData.errorMessage
              },
              callbacks: {
                eventOnClose: () => {
                  this.$router.push(this.$route.path, () => {})
                }
              }
            })
          }

          return
        }

        if (datatransPaymentReponseData.status === 'success') {
          const emitParams = { action: 'USER_PAYMENT_UPDATED', payload: datatransPaymentReponseData }

          if (this.emitEvent) {
            this.emitEvent(emitParams.action, emitParams.payload)
          }

          // Open dialog if plans page
          if (isPlansPage && this.$refs.dialog) {
            if (_.isFunction(this.handleDatatransResponseData)) {
              this.handleDatatransResponseData({
                success: true,
                data: datatransPaymentReponseData
              })
            }

            return
          }

          this.$router.push(this.$route.path, () => {})
        }
      }
    }
  },
  mounted () {
    this.datatransLightboxPaymentResponseData()
  }
}
